module.exports = __webpack_public_path__ + "img/b18b04f.jpg";